import {IconWeightType} from '../enum/IconWeightType'

import {IconPrefix} from '@fortawesome/fontawesome-svg-core'

export const IconWeightTypeToClassNameMap = new Map<IconWeightType, IconPrefix>([
  [IconWeightType.Solid, 'fas'],
  [IconWeightType.Regular, 'far'],
  [IconWeightType.Bold, 'fab'],
  [IconWeightType.Kit, 'kit' as IconPrefix],
])

